import '../styles/globals.css';
// Temporarily commenting out this import as it's not compatible with Tailwind v4
// import '@1debit/chimekit/dist/tailwind-config/styles.css';

import type { AppProps } from 'next/app';
import Head from 'next/head';
import { Layout } from 'components/Layout';
import { EventRouterAnalyticsProvider } from 'contexts/EventRouterAnalytics';

function MyApp({ Component, pageProps }: AppProps) {
	return (
		<>
			<Head>
				<title>Chime</title>
				<meta name="description" content="Generated by create next app" />
				<link rel="icon" href="/assets/favicon.ico" />
			</Head>
			<EventRouterAnalyticsProvider>
				<Layout>
					<Component {...pageProps} />
				</Layout>
			</EventRouterAnalyticsProvider>
		</>
	);
}

export default MyApp;
